import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import {baseUrl, ipAddress, userLocation, userName} from "../Univ.js";
function LeadList() {
    const [activities, setActivities] = useState([]);
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [form, setForm] = useState({
        name: "",
        phone: "",
        area: "",
        note: "",
        outcome: "",
        email: "",
    });
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        fetchActivities();
    }, []);
    const fetchActivities = () => {
        setIsLoading(true);
        axios
            .get(`${baseUrl}activities/`)
            .then((res) => setActivities(res.data))
            .catch((err) => console.error(err))
            .finally(() => setIsLoading(false));
    };
    // Create new activity
    const submitActivity = () => {
        axios
            .post(`${baseUrl}activities/`, {
                ...form,
                staff_user: userName,
                addedby: userName,
                ip_add: ipAddress,
                location: userLocation,
            })
            .then(() => {
                Swal.fire("Success", "Activity created successfully", "success");
                setForm({name: "", phone: "", area: "", note: "", outcome: "", email: ""});
                fetchActivities();
            })
            .catch(() => Swal.fire("Error", "Failed to create activity", "error"));
    };
    // Open update modal
    const handleUpdateClick = (activity) => {
        setSelectedActivity({...activity});
        setSelectedDateTime(activity.reminder_date ? new Date(activity.reminder_date) : null);
    };
    // Handle modal field changes
    const handleChange = (e) => {
        const {name, value} = e.target;
        setSelectedActivity((prev) => ({...prev, [name]: value}));
    };
    // DatePicker change handler
    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
        setSelectedActivity((prev) => ({
            ...prev,
            reminder_date: datetime, // Update the selectedActivity object
        }));
    };
    const handleSave = async () => {
        if (!selectedActivity) return;
        const payload = {
            id: selectedActivity.id,
            status: selectedActivity.status,
            phone: selectedActivity.phone,
            name: selectedActivity.name,
            area: selectedActivity.area,
            note: selectedActivity.note,
            email: selectedActivity.email,
            outcome: selectedActivity.outcome,
            reminder_date: selectedActivity.reminder_date
                ? new Date(selectedActivity.reminder_date).toISOString()
                : null,
            ip_add: ipAddress,
        };
        try {
            const res = await axios.post(`${baseUrl}update-activity/`, payload);
            if (res.data?.message === "Activity updated successfully") {
                Swal.fire("Updated", "Activity updated successfully", "success");
                setTimeout(() => {
                    window.location.href = '/lead-list';
                }, 1000);
                fetchActivities();
                // Hide modal without using window.bootstrap
                const modalEl = document.getElementById("updateActivityModal");
                const modal = bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);
                modal.hide();
                // Clear selected activity
                setSelectedActivity(null);
            } else {
                Swal.fire("Error", "Failed to update activity", "error");
            }
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Failed to update activity", "error");
        }
    };
    const statusMapping = {
        1: {label: "Cold", color: "#6c757d"},   // Grey
        2: {label: "Hot", color: "#dc3545"},    // Red
        3: {label: "Dead", color: "#198754"},   // Green
    };
    const columns = [
        {field: "id", headerName: "ID", width: 70},
        {field: "name", headerName: "Lead Name", width: 150},
        {field: "area", headerName: "Area", width: 100},
        {field: "phone", headerName: "Phone", width: 150},
        {
            field: "status",
            headerName: "Status",
            width: 120,
            renderCell: (params) => {
                const status = statusMapping[params.value] || {label: "Unknown", color: "#6c757d"};
                return (
                    <span
                        style={{
                            display: "inline-block",
                            padding: "4px 8px",
                            borderRadius: "12px",
                            fontWeight: "bold",
                            color: "white",
                            backgroundColor: status.color,
                        }}
                    >
              {status.label}
            </span>
                );
            },
        },
        {field: "email", headerName: "Email", width: 200},
        {field: "note", headerName: "Notes", width: 200},
        {
            field: "noteOutcome",
            headerName: "Outcome",
            width: 300,
            renderCell: (params) => {
                const outcome = params.row.outcome || "";
                // Split outcome by comma
                const outcomeParts = outcome.split(",").map((part) => part.trim());
                return (
                    <div
                        style={{
                            whiteSpace: "normal",
                            lineHeight: "1.4",
                            wordWrap: "break-word",
                        }}
                    >

                        <strong>Outcome:</strong>
                        <div>
                            {outcomeParts.map((part, index) => (
                                <React.Fragment key={index}>
                                    {part}
                                    {index !== outcomeParts.length - 1 && <br/>}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                );
            },
        },
        {
            field: "reminder_date",
            headerName: "Reminder",
            width: 300,
            renderCell: (params) => {
                const reminder_date = params.row.reminder_date || "";
                // Split outcome by comma
                const reminder_dates = reminder_date.split(",").map((part) => part.trim());
                return (
                    <div
                        style={{
                            whiteSpace: "normal",
                            lineHeight: "1.4",
                            wordWrap: "break-word",
                        }}
                    >
                        <div>
                            {reminder_dates.map((part, index) => (
                                <React.Fragment key={index}>
                                    {part}
                                    {index !== reminder_dates.length - 1 && <br/>}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                );
            },
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 120,
            renderCell: (params) => (
                <button
                    className="btn btn-sm btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#updateActivityModal"
                    onClick={() => handleUpdateClick(params.row)}
                >
                    Update
                </button>
            ),
        },
    ];
    return (
        <section className="container mt-4">

            <div className="row">
                <h3>Lead Activities</h3>

                {/* Create Activity Form */}
                <div className="card p-3 mb-4 shadow-sm">
                    <h5>Add New Lead Activity</h5>
                    <input
                        className="form-control mb-2"
                        placeholder="Lead Name"
                        value={form.name}
                        onChange={(e) => setForm((f) => ({...f, name: e.target.value}))}
                    />
                    <input
                        className="form-control mb-2"
                        placeholder="Area"
                        value={form.area}
                        onChange={(e) => setForm((f) => ({...f, area: e.target.value}))}
                    />
                    <input
                        className="form-control mb-2"
                        placeholder="Phone"
                        value={form.phone}
                        onChange={(e) => setForm((f) => ({...f, phone: e.target.value}))}
                    />
                    <input
                        className="form-control mb-2"
                        placeholder="Email"
                        value={form.email}
                        onChange={(e) => setForm((f) => ({...f, email: e.target.value}))}
                    />
                    <textarea
                        className="form-control mb-2"
                        placeholder="Notes"
                        value={form.note}
                        onChange={(e) => setForm((f) => ({...f, note: e.target.value}))}
                    />
                    <textarea
                        className="form-control mb-2"
                        placeholder="Call Outcome"
                        value={form.outcome}
                        onChange={(e) => setForm((f) => ({...f, outcome: e.target.value}))}
                    />
                    <button className="btn btn-primary" onClick={submitActivity}>
                        Add Activity
                    </button>
                </div>

                {/* Activities Table */}
                <div className="row mt-4">
                    {!isLoading && activities.length > 0 ? (
                        <div style={{height: "100%", width: "100%"}}>
                            <DataGrid
                                sx={{
                                    boxShadow: 4,
                                    border: 4,
                                    borderColor: 'primary.light',
                                    '& .MuiDataGrid-cell:hover': {
                                        color: 'primary.main',
                                    },
                                }}
                                rows={activities}
                                columns={columns}
                                pageSize={10}
                                slots={{toolbar: GridToolbar}}
                                getRowHeight={() => 'auto'}
                                autoHeight
                                className="mt-4"
                            />
                        </div>
                    ) : (
                        <p>No activities found.</p>
                    )}
                </div>

                {/* Update Activity Modal */}
                <div
                    className="modal fade"
                    id="updateActivityModal"
                    tabIndex="-1"
                    aria-labelledby="updateActivityModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="updateActivityModalLabel">
                                    Update Activity
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                {selectedActivity && (
                                    <form>
                                        <label className="form-label">Lead Name:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={selectedActivity.name || ""}
                                            onChange={handleChange}
                                        />

                                        <label className="form-label">Area:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="area"
                                            value={selectedActivity.area || ""}
                                            onChange={handleChange}
                                        />

                                        <label className="form-label">Phone:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="phone"
                                            value={selectedActivity.phone || ""}
                                            onChange={handleChange}
                                        />

                                        <label className="form-label">Email:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="email"
                                            value={selectedActivity.email || ""}
                                            onChange={handleChange}
                                        />
                                        <label className="form-label">Status:</label>
                                        <select
                                            className="form-control"
                                            name="status"
                                            value={selectedActivity.status || ""}
                                            onChange={handleChange}
                                        >
                                            <option value={1}>Cold</option>
                                            <option value={2}>Hot</option>
                                            <option value={3}>Dead</option>
                                        </select>

                                        <label className="form-label">Notes:</label>
                                        <textarea
                                            className="form-control"
                                            name="note"
                                            value={selectedActivity.note || ""}
                                            onChange={handleChange}
                                        />

                                        <label className="form-label">Call Outcome:</label>
                                        <textarea
                                            className="form-control"
                                            name="outcome"
                                            value={selectedActivity.outcome || ""}
                                            onChange={handleChange}
                                        />

                                        <label className="form-label">Reminder Date:</label>
                                        <DatePicker className="form-control" name="reminder_date" id="reminder_date"
                                                    selected={selectedDateTime}
                                                    onChange={handleDateTimeChange}
                                                    dateFormat="yyyy-MM-dd h:mm"
                                                    showTimeSelect
                                                    timeIntervals={15}
                                                    timeCaption="Time"
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-primary mt-3"
                                            onClick={handleSave}
                                        >
                                            Save Changes
                                        </button>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default LeadList;
